import React from "react";

export const countChildren = (array) => [...Array(Number(array.length) || 0)];

const isEmpty = (s) => s === null || s?.length === 0 || !s?.trim();
export const textToList = (text) => {
  if (isEmpty(text)) return [];
  return text.split("\n").filter((txt) => !isEmpty(txt));
};

export const range = ({ start, end }) => {
  if (start && end) {
    return [...Array.from(Array(end - start + 1), (_, i) => i + start)];
  } else if (end) {
    return [...Array(end + 1).keys()];
  }
  return [];
};

export const doubleChildren = (children) => {
  const clonedChildren = React.Children.map(children, (child) => {
    return React.cloneElement(child, { key: child.key + 1000000 });
  });

  return [...children, ...clonedChildren];
};
